import React, { Component } from "react";
import { Service } from "../../../../service/service";
import { API } from "../../../../../const";
import {
  getEtatSanteToString,
  iconSanteSwitch,
  getObjetSanteToString,
} from "../../../../../ReactConst";
import _ from "lodash";
import Img from "react-image";
import srciconHistoriques from "../../../../../styles/img/icon-historique-medical.svg";
import srcIconCoeur from "../../../../../styles/img/etat-sante-red.svg";
import srcIconMedicament from "../../../../../styles/img/icon-medicament.svg";
import Lightbox from "lightbox-react";
import "lightbox-react/style.css"; // This only needs to be imported once in your app
import moment from "moment";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import { connect } from "react-redux";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class HistoSante extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlOrdonnancesTraitements: [],
      tempUrlOrdonnancesTraitements: [],
      urlOrdonnancesHistoriques: [],
      photoIndex: 0,
      isOpenTraitment: false,
      isOpenHistorique: false,
      fromArchive: window.location.pathname.includes("archives"),
      uploadingCarnet: false,
      deletingCarnet: false,
      urlCarnetSante: null,
      isOpenCarnet: false,
    };
    this.onClickOrdonnacesHistoriques = this.onClickOrdonnacesHistoriques.bind(
      this
    );
    this.handleCarnetUpload = this.handleCarnetUpload.bind(this);
    this.handleCarnetDelete = this.handleCarnetDelete.bind(this);
  }
  componentWillMount() {
    if (!_.isEmpty(this.props.values.medicalFolder) &&
        !_.isEmpty(this.props.values.medicalFolder.urlCarnetSante)) {
      this.setState({ urlCarnetSante: this.props.values.medicalFolder.urlCarnetSante });
    }
    if (!_.isEmpty(this.props.values.traitementsList)) {
      var listTraitementsOrdonnances = [];
      if (this.props.values.traitementsList.length == 1) {
        listTraitementsOrdonnances.unshift(
          this.props.values.traitementsList[0].ordonnance.urlOrdonnance
        );
        this.setState({
          urlOrdonnancesTraitements: listTraitementsOrdonnances,
        });
      } else {
        this.props.values.traitementsList.map((element) => {
          listTraitementsOrdonnances.push(element.ordonnance.urlOrdonnance);
        });
        this.setState({
          urlOrdonnancesTraitements: listTraitementsOrdonnances,
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    const prevUrl = prevProps.values.medicalFolder && prevProps.values.medicalFolder.urlCarnetSante;
    const newUrl = this.props.values.medicalFolder && this.props.values.medicalFolder.urlCarnetSante;
    if (newUrl !== prevUrl && newUrl !== this.state.urlCarnetSante) {
      this.setState({ urlCarnetSante: newUrl || null });
    }
  }

  onClickOrdonnacesHistoriques = (urlOdonanceHistorique) => {
    let listHistoriquesOrdonnances = [];

    listHistoriquesOrdonnances.unshift(urlOdonanceHistorique);
    this.setState({
      urlOrdonnancesHistoriques: listHistoriquesOrdonnances,
    });
  };

  handleCarnetUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    let tok = localStorage.getItem("token");
    let id = window.location.pathname.match(/\d+/g)[0];

    this.setState({ uploadingCarnet: true });

    let formPayload = new FormData();
    formPayload.append("file", file);

    const uploadResponse = Service.post(
      `${API}api/creche/files?category=CARNET_SANTE`,
      formPayload,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    uploadResponse.then((res) => {
      const idFichier = res.data.files[0].fileId;
      const attachResponse = Service.put(
        `${API}api/enfant/creche/enfants/${id}/dossier-medical/carnet-sante`,
        { idFichier: idFichier },
        { headers: { Authorization: `Bearer ${tok}` } }
      );
      attachResponse.then(() => {
        const reloadResponse = Service.get(
          `${API}api/enfant/creche/enfants/${id}/dossier-medical`,
          { headers: { Authorization: `Bearer ${tok}` } }
        );
        reloadResponse.then((res) => {
          this.setState({
            uploadingCarnet: false,
            urlCarnetSante: res.data.urlCarnetSante,
          });
        });
        reloadResponse.catch((err) => {
          console.error("Erreur rechargement dossier medical", err);
          this.setState({ uploadingCarnet: false });
        });
      });
      attachResponse.catch((err) => {
        console.error("Erreur rattachement carnet de santé", err);
        this.setState({ uploadingCarnet: false });
      });
    });
    uploadResponse.catch((err) => {
      console.error("Erreur upload carnet de santé", err);
      this.setState({ uploadingCarnet: false });
    });

    event.target.value = null;
  };

  handleCarnetDelete = () => {
    let tok = localStorage.getItem("token");
    let id = window.location.pathname.match(/\d+/g)[0];

    this.setState({ deletingCarnet: true });

    const response = Service.deleteOne(
      `${API}api/enfant/creche/enfants/${id}/dossier-medical/carnet-sante`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then(() => {
      this.setState({
        deletingCarnet: false,
        urlCarnetSante: null,
      });
    });
    response.catch((err) => {
      console.error("Erreur suppression carnet de santé", err);
      this.setState({ deletingCarnet: false });
    });
  };

  render() {
    const { fromArchive } = this.state;
    var photoIndex = this.state.photoIndex;
    return (
      <div
        className="tab-pane show active "
        id="historique-medical-pane"
        role="tabpanel"
        aria-labelledby="historique-medical-tab"
      >
        {this.props.loading ? (
          <div className="content p-0">
            <DotLoader
              size={100}
              color={"#ff7d26"}
              css={override}
              loading={this.props.loading}
            />
          </div>
        ) : (
          <div className="content p-0">
            {fromArchive ? (
              ""
            ) : (
              <>
                <section className="content-section">
                  <h2>Son état de santé aujourd'hui</h2>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="bloc-recap blue">
                        <div className="title">État de santé</div>
                        {!_.isEmpty(this.props.values.medicalFolder) &&
                        !_.isEmpty(
                          this.props.values.medicalFolder.etatSante
                        ) ? (
                          <div className="d-flex align-items-center justify-content-center content-recap">
                            <Img
                              src={srcIconCoeur}
                              className="img-fluid icon-etat-sante"
                              alt=""
                            />
                            <span className="libelle">
                              {getObjetSanteToString(
                                this.props.values.medicalFolder.etatSante
                                  .etatSante
                              )}
                            </span>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center justify-content-center content-recap">
                            <Img
                              src={srciconHistoriques}
                              className="img-fluid icon-etat-sante"
                              alt=""
                            />
                            <span className="libelle">Rien à signaler</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="bloc-recap blue">
                        <div className="title">Traitement en cours</div>
                        {!_.isEmpty(this.props.values.traitementsList) ? (
                          <div className="row align-items-center">
                            <div className="col-md-6 d-flex align-items-center justify-content-center content-recap">
                              <div className="col-md-4 d-flex align-items-center justify-content-center  ">
                                <Img
                                  src={srcIconMedicament}
                                  className="img-fluid icon-etat-sante"
                                  alt=""
                                />
                              </div>
                              <div className="col-md-8 d-flex align-items-center flex-wrap ">
                                <p className="contre-indic-elements">
                                  {this.props.values.traitementsList.map(
                                    (element, index) => {
                                      let sperator =
                                        index ===
                                        this.props.values.traitementsList
                                          .length -
                                          1
                                          ? ""
                                          : " ,";
                                      return (
                                        <span key={index}>
                                          {" " + element.titre + sperator}
                                        </span>
                                      );
                                    }
                                  )}
                                </p>
                              </div>
                            </div>
                            {!_.isEmpty(this.props.values.traitementsList) ? (
                              <div className="col-md-6">
                                <a
                                  href="#"
                                  className="btn-gradient"
                                  onClick={() => {
                                    var tempUrlOrdonnancesTraitements = this
                                      .state.urlOrdonnancesTraitements;
                                    this.setState({
                                      isOpenTraitment: true,
                                      tempUrlOrdonnancesTraitements,
                                    });
                                  }}
                                >
                                  Voir l'ordonnance
                                </a>
                              </div>
                            ) : null}
                          </div>
                        ) : (
                          <div className="row align-items-center">
                            <div className="col-md-6 d-flex align-items-center justify-content-center content-recap">
                              <div className="col-md-4 d-flex align-items-center justify-content-center  ">
                                <Img
                                  src={srcIconMedicament}
                                  className="img-fluid icon-etat-sante"
                                  alt=""
                                />
                              </div>
                              <div className="col-md-8 d-flex align-items-center flex-wrap ">
                                <p className="contre-indic-elements">
                                  Aucun traitement
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </>
            )}

            <section className="content-section">
              <h2>Contre-indications</h2>
              <div className="row row-contre-indic align-items-stretch">
                <div className="col-md-4">
                  <div className="bloc-contre-indic">
                    <p className="title">Allergies</p>
                    {!_.isEmpty(this.props.values.medicalFolder) &&
                    !_.isEmpty(
                      this.props.values.medicalFolder.contreIndications
                    ) &&
                    !_.isEmpty(
                      this.props.values.medicalFolder.contreIndications
                        .allergies
                    ) ? (
                      <p className="contre-indic-elements">
                        {!_.isEmpty(this.props.values.medicalFolder) &&
                          this.props.values.medicalFolder.contreIndications.allergies.join(
                            "-"
                          )}
                      </p>
                    ) : (
                      <p className="contre-indic-elements"> Aucune</p>
                    )}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="bloc-contre-indic">
                    <p className="title">Intolérances</p>
                    {!_.isEmpty(this.props.values.medicalFolder) &&
                    !_.isEmpty(
                      this.props.values.medicalFolder.contreIndications
                    ) &&
                    !_.isEmpty(
                      this.props.values.medicalFolder.contreIndications
                        .intolerances
                    ) ? (
                      <p className="contre-indic-elements">
                        {!_.isEmpty(this.props.values.medicalFolder) &&
                          this.props.values.medicalFolder.contreIndications.intolerances.join(
                            "-"
                          )}
                      </p>
                    ) : (
                      <p className="contre-indic-elements">Aucune</p>
                    )}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="bloc-contre-indic">
                    <p className="title">Activités</p>
                    {!_.isEmpty(this.props.values.medicalFolder) &&
                    !_.isEmpty(
                      this.props.values.medicalFolder.contreIndications
                    ) &&
                    !_.isEmpty(
                      this.props.values.medicalFolder.contreIndications
                        .activites
                    ) ? (
                      <p className="contre-indic-elements">
                        {!_.isEmpty(this.props.values.medicalFolder) &&
                          this.props.values.medicalFolder.contreIndications.activites.join(
                            "-"
                          )}
                      </p>
                    ) : (
                      <p className="contre-indic-elements">Aucune</p>
                    )}
                  </div>
                </div>
              </div>
            </section>
            <section className="content-section">
              <h2>Carnet de santé</h2>
              {!_.isEmpty(this.props.values.medicalFolder) &&
              !_.isEmpty(this.state.urlCarnetSante) ? (
                <div>
                  {(() => {
                    const url = this.state.urlCarnetSante;
                    const path = url.split("?")[0].toLowerCase();
                    const isImage = path.endsWith(".jpg") || path.endsWith(".jpeg") || path.endsWith(".png");
                    if (isImage) {
                      return (
                        <div style={{ textAlign: "center", marginBottom: "15px" }}>
                          <img
                            src={url}
                            alt="Carnet de santé"
                            style={{ maxWidth: "100%", maxHeight: "500px", borderRadius: "8px", cursor: "pointer", border: "1px solid #ddd" }}
                            onClick={() => this.setState({ isOpenCarnet: true })}
                          />
                        </div>
                      );
                    } else {
                      return (
                        <div style={{ marginBottom: "15px" }}>
                          <iframe
                            src={url}
                            title="Carnet de santé"
                            style={{ width: "100%", height: "600px", border: "1px solid #ddd", borderRadius: "8px" }}
                          />
                        </div>
                      );
                    }
                  })()}
                  <div className="d-flex align-items-center">
                    {!fromArchive && (
                      <>
                        <button
                          type="button"
                          className="btn-white btn-border"
                          onClick={this.handleCarnetDelete}
                          disabled={this.state.deletingCarnet}
                          style={{ marginRight: "10px" }}
                        >
                          {this.state.deletingCarnet ? "Suppression..." : "Supprimer"}
                        </button>
                        <label
                          htmlFor="carnet-sante-upload"
                          className="btn-white btn-border"
                          style={{ cursor: "pointer" }}
                        >
                          {this.state.uploadingCarnet ? "Envoi en cours..." : "Remplacer le fichier"}
                        </label>
                        <input
                          id="carnet-sante-upload"
                          type="file"
                          accept=".pdf,.jpg,.jpeg,.png"
                          style={{ display: "none" }}
                          onChange={this.handleCarnetUpload}
                          disabled={this.state.uploadingCarnet}
                        />
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center">
                  <p className="contre-indic-elements" style={{ marginRight: "15px" }}>Aucun carnet de santé</p>
                  {!fromArchive && (
                    <>
                      <label
                        htmlFor="carnet-sante-upload"
                        className="btn-gradient"
                        style={{ cursor: "pointer" }}
                      >
                        {this.state.uploadingCarnet ? "Envoi en cours..." : "Ajouter un fichier"}
                      </label>
                      <input
                        id="carnet-sante-upload"
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        style={{ display: "none" }}
                        onChange={this.handleCarnetUpload}
                        disabled={this.state.uploadingCarnet}
                      />
                    </>
                  )}
                </div>
              )}
            </section>

            {_.isEmpty(this.props.values.medicalFolder.historique) ? (null
            ) : (
              <section className="content-section border-0 mb-0">
                <h2>Historique</h2>
                <table className="table table-striped table-style table-sm">
                  <thead>
                    <tr>
                      <th style={{ width: "20%" }}>Date</th>
                      <th>Évènement</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.values.medicalFolder.historique.map((event) => (
                      <tr>
                        <td>
                          {moment(event.dateTimeDebut).format("DD[/]MM[/]YYYY")}
                        </td>
                        <td className="row">
                          <span style={{ paddingLeft: "15px" }}>{event.description} </span>
                          <span style={{ paddingLeft: "10px" }}>
                            {!_.isEmpty(event.urlOrdonance) ? (
                              <a
                                href="#"
                                className="btn-gradient"
                                onClick={() => {
                                  this.onClickOrdonnacesHistoriques(
                                    event.urlOrdonance
                                  );
                                  this.setState({
                                    isOpenHistorique: true,
                                  });
                                }}
                              >
                                Voir l'ordonnance
                              </a>
                            ) : (
                              " "
                            )}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </section>
            )}
          </div>
        )}

        {this.state.urlOrdonnancesTraitements.length > 0 &&
        this.state.isOpenTraitment == true ? (
          <Lightbox
            mainSrc={this.state.urlOrdonnancesTraitements[photoIndex]}
            nextSrc={
              this.state.urlOrdonnancesTraitements[
                (photoIndex + 1) % this.state.urlOrdonnancesTraitements.length
              ]
            }
            prevSrc={
              this.state.urlOrdonnancesTraitements[
                (photoIndex + this.state.urlOrdonnancesTraitements.length - 1) %
                  this.state.urlOrdonnancesTraitements.length
              ]
            }
            onCloseRequest={() => {
              this.setState({
                isOpenTraitment: false,
                photoIndex: 0,
                tempUrlOrdonnancesTraitements: [],
              });
            }}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex +
                    this.state.urlOrdonnancesTraitements.length -
                    1) %
                  this.state.urlOrdonnancesTraitements.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + 1) %
                  this.state.urlOrdonnancesTraitements.length,
              })
            }
          />
        ) : null}

        {this.state.isOpenCarnet && this.state.urlCarnetSante ? (
          <Lightbox
            mainSrc={this.state.urlCarnetSante}
            onCloseRequest={() => this.setState({ isOpenCarnet: false })}
          />
        ) : null}

        {this.state.urlOrdonnancesHistoriques.length > 0 &&
        this.state.isOpenHistorique == true ? (
          <Lightbox
            mainSrc={this.state.urlOrdonnancesHistoriques[photoIndex]}
            nextSrc={
              this.state.urlOrdonnancesHistoriques[
                (photoIndex + 1) % this.state.urlOrdonnancesHistoriques.length
              ]
            }
            prevSrc={
              this.state.urlOrdonnancesHistoriques[
                (photoIndex + this.state.urlOrdonnancesHistoriques.length - 1) %
                  this.state.urlOrdonnancesHistoriques.length
              ]
            }
            onCloseRequest={() => {
              this.setState({ isOpenHistorique: false, photoIndex: 0 });
            }}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex +
                    this.state.urlOrdonnancesHistoriques.length -
                    1) %
                  this.state.urlOrdonnancesHistoriques.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + 1) %
                  this.state.urlOrdonnancesHistoriques.length,
              })
            }
          />
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.ficheEnfant.HistoSante.loading,
});
export default connect(mapStateToProps, {})(HistoSante);
